import { useState } from 'react'
import { useParams } from 'react-router-dom'

import { ReactComponent as Logo } from 'shared/assets/icons/logo-admin.svg'
import NewPageModal from 'shared/components/PageList/components/modals/NewPageModal'
import LogoContainerLink from 'shared/layout/Default/components/Header/components/LogoContainerLink'
import { LiveUser } from 'shared/types/global'
import Button from 'shared/ui/Button_2'
import Flex from 'shared/ui/Flex'
import LiveAvatarsRow from 'shared/ui/LiveAvatarsRow'

type HeaderProps = {
  liveUsers: LiveUser[]
  currentView: 'content' | 'cover'
  tools: JSX.Element
  onSaveAndLeave: () => void
  isSaveLoading: boolean
}

const AdminProjectCoverEditorHeader: React.FC<HeaderProps> = ({
  liveUsers,
  tools,
  onSaveAndLeave,
  isSaveLoading
}) => {
  const { groupId, projectId } = useParams()
  const [isNewPageModalOpen, setIsNewPageModalOpen] = useState(false)

  return (
    <Flex justifyContent="space-between">
      <Flex columnGap={16} alignItems="center">
        <Button
          loading={isSaveLoading}
          textId="Editor.leaveButton"
          intent="primary-brand-02"
          onPress={onSaveAndLeave}
          icon="left"
          iconName="save"
          minWidth={162}
        />
        <LogoContainerLink to="/admin/projects">
          <Logo />
        </LogoContainerLink>
      </Flex>

      {tools}
      <Flex alignItems="center" columnGap={48}>
        <LiveAvatarsRow liveUsers={liveUsers || []} />
      </Flex>

      <NewPageModal
        groupId={groupId!}
        projectId={projectId!}
        isOpen={isNewPageModalOpen}
        closeModal={() => setIsNewPageModalOpen(false)}
      />
    </Flex>
  )
}

export default AdminProjectCoverEditorHeader
